import { 
    findClientsByCompany, 
    findClientsBySellerCompany, 
    findClientById, 
    downloadPricesBySeller,
    findAllClientsNamesByCompany,
    downloadClientsBySeller
} from '../../_services/client.service';
import { getCompany, getUserId } from '../../_utils/storage_handler';

export const findAllClientsByCompanyEvent = async () => {
    let res = await findClientsByCompany(getCompany());
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const findAllClientsNamesByCompanyEvent = async () => {
    let res = await findAllClientsNamesByCompany(getCompany());
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const findClientsBySellerCompanyEvent = async () => {
    let res = await findClientsBySellerCompany(getUserId(), getCompany());
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const findClientByIdEvent = async (id) => {
    let res = await findClientById(id);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const downloadPricesBySellerEvent = async (seller) => {
    let res = await downloadPricesBySeller(seller);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const downloadClientsBySellerEvent = async (seller) => {
    let res = await downloadClientsBySeller(seller);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}